export const PREVIEW_DEBOUNCE_MS = 500;
export const SANDBOX_LOAD_TIMEOUT_MS = 10_000;

// Fallback iframe dimensions used when the creative's width/height are not yet
// known (e.g. the form fields are empty or onDimensionsDetected hasn't fired).
// 728 matches the IAB Leaderboard width — the most common banner format.
// 500 is a generous height so fitScale math works before real dimensions arrive.
export const DEFAULT_IFRAME_WIDTH = 728;
export const DEFAULT_IFRAME_HEIGHT = 500;
